export default __webpack_public_path__ + "static/media/stage-1-dorsal-motor-x-nucleus.3e60fbd1.png";